import React from 'react'

const PaymentOptionsTextTurkish = ()=> {
  return(
   <div className="terms-text">
      <h2>Sipariş Ödemesi</h2>
      <p>
        Şirketimizde müşterilerimize en iyi hizmeti sunmak için elimizden geleni yapıyoruz. Bu nedenle mümkün olduğunca fazla ödeme yöntemi sunuyoruz.
      </p>    
      <h2>
        Kredi Kartı – Banka Kartı
      </h2>
      <p>
        Mağazamızda tüm bankaların kredi, banka veya ön ödemeli kartlarını kabul ediyoruz. Fiziksel mağazamızdan ödeme yapılması durumunda, ödeme POS cihazı ile gerçekleştirilir. Online mağazamızdan alışveriş yapılması ve kredi kartı ile ödeme durumunda, kullanıcı partner banka kuruluşunun (Viva, PayPal) güvenli ortamına yönlendirilir. Bu web sitesi güvenlidir ve SSL sertifikası ile korunmaktadır. Kullanılacak kredi kartı, banka kartı veya ön ödemeli kart bilgileri bize açıklanmaz ve şirketimizde saklanmaz.
      </p>
      <h2>
        Mağazadan Teslim Alma
      </h2>
      <p>
        Ürünlerinizi mağazamızdan teslim almayı seçerseniz, sipariş tutarını da mağazada ödersiniz.
      </p>
    </div>
  )
}
    
export default PaymentOptionsTextTurkish;